import { type QueryFilter, type NormalizedSearchResultDto, httpGet, SearchResultDto } from "./claimsInvoicingApi";
import { ClaimsDetailsDto, MemberDetailsDto, ClaimsInfoByBranchDto } from "@/types";
export const getClaims = async (
    id: number,
    params: ClaimsQueryFilter
): Promise<NormalizedSearchResultDto<ClaimsItemDto>> => {
    // Prepare params for backend (1-based page)
    const { page, ...rest } = params;
    const queryParams = { page: page + 1, ...rest };
    // Fetch data
    const raw: SearchResultDto<ClaimsItemDto> =
        id === 0
            ? await httpGet(`/claims/company/`, { params: queryParams })
            : await httpGet(`/claims/company/${id}`, { params: queryParams });

    // Normalize for UI (0-based page)
    return {
        items: raw.items,
        returnedResults: raw.returnedResults,
        pageIndex: Math.max(0, raw.page - 1),
        totalResults: raw.totalResults
    };
};

export const getClaimsInfo = async (claimsId: string): Promise<ClaimsDetailsDto> => httpGet(`/claims/${claimsId}`);

export const getClaimsMember = async (claimsId: string): Promise<MemberDetailsDto> =>
    httpGet(`/claims/${claimsId}/member`);

export const getClaimsInfoByBranch = async (claimsId: string, crmId: string): Promise<ClaimsInfoByBranchDto> =>
    httpGet(`/claims/${claimsId}/branch/${crmId}`);

export const getClaimRecipientDetails = async (claimsId: string, crmId?: string): Promise<MemberDetailsDto> =>
    httpGet(`/claim/recipient/${claimsId}?crmId=${crmId}`);

export const getSubclaimHandlerEmail = async (claimsId: string, subClaimId: string): Promise<{ email: string }> =>
    httpGet(`/claims/${claimsId}/subclaims/${subClaimId}/handler-email`);

export const getCompanyAssignedSubclaimsOfClaim = async (claimsId: string, crmId: string): Promise<string[]> => {
    const result: AssignedSubclaimsDto = await httpGet(`/claims/${claimsId}/assigned-subclaims/${crmId}`);
    return result.subclaimReferences ?? [];
};

const DEFAULT_LIMIT = 10;
export const DEFAULT_QUERY_FILTER: ClaimsQueryFilter = {
    page: 0, // 0-based for UI
    limit: DEFAULT_LIMIT,
    sortDirection: "DESC",
    status: "Open"
};

export type ClaimParams = {
    companyId?: number | null;
    queryFilter: ClaimsQueryFilter;
};

export type ClaimsByBranchDto = {
    claimsId: string;
    crmId: string;
};

export type ClaimsItemDto = {
    id: string;
    status: string;
    incidentDate: string;
    description: string;
    invoiceCount: number;
    vesselName: string;
    clientName: string;
};

type ClaimsQueryFilter = QueryFilter & {
    status?: "Open" | "Closed";
};

type AssignedSubclaimsDto = {
    subclaimReferences?: string[];
    totalCount?: number;
};
